var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-description",class:{ error: _vm.error }},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.description))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }